import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

type Props = {
  className?: string;
};

export const LoadingIcon = ({ className }: Props) => {
  return <Loader2 className={cn('text-muted-foreground h-6 w-6 animate-spin', className)} />;
};
